/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SocialPinterest.vue?vue&type=template&id=071acc93&"
import script from "./SocialPinterest.vue?vue&type=script&lang=js&"
export * from "./SocialPinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports